module.exports = __webpack_public_path__ + "img/telegramlogo.c0d1aa7a.png";